<template>
    <div class="pointPage">
        <div class="headerClass">{{ Headertitle }}</div>
        <div class="pointContent">
            <v-search
                :formContent="formContent"
                :SearchForm="SearchForm"
                :inline="true"
                :optareBtn="optareBtn"
                @resetFn="resetFn"
                @confirmFn="getListFn"
                @searchFn="getListFn"
                @appoveFn="appoveFn"
                @exportFn="exportFn"
                class="vSearch"
            />
            <div class="question">
                <span v-for="(i, key) in approvalStatus" :key="key" class="icon-margin">
                    <i :class="i.icon" class="icon-margin"></i><span>{{ $t(i.title) }}</span>
                </span>
            </div>
            <pointTable
                :tableData="tableData"
                :loading="loading"
                @detailFn="detailFn"
                @delRowFn="delRowFn"
                @choozeTable="choozeTable"
                @approveFn="approveFn($event, 1)"
                @noApproveFn="approveFn($event, 0)"
            />
            <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart" :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
        </div>
        <!-- 数据记录弹窗 -->
        <DataPoint :title="title" :isPointShow.sync="isPointShow" :pointId="pointId" />
        <!-- 审批 -->
        <Approve :isShow.sync="isShow" :title="title" :choozeTableData="choozeTableData" />
    </div>
</template>

<script>
import { carrierRecordList, carrieDel, carrieExport, carrierRecordUpdate, carrierRecordDetail } from '@/api/modules/record.js';

import formMixin from '@/utils/formMixins.js';

import { approvalStatus } from '@/utils/convert';

import pointTable from './pointTable.vue';
import DataPoint from './/dataPoint.vue';
import Approve from './Approve.vue';
import { getLanguage } from '@/lang';

export default {
    mixins: [formMixin],
    components: {
        pointTable,
        DataPoint,
        Approve
    },
    beforeRouteEnter(to, from, next) {
        document.title = to.query['fullpath'];
        next();
    },
    data() {
        return {
            approvalStatus,
            title: '',
            total: 0,
            Headertitle: '',
            formContent: [
                {
                    id: 1,
                    text: $t('integration.record_date'),
                    type: 'date',
                    paramsName: 'startDateArray',
                    isChooze: true
                },
                {
                    id: 2,
                    text: $t('integration.approval_time'),
                    type: 'datetimerange',
                    paramsName: 'time',
                    isChooze: false
                },
                {
                    id: 3,
                    text: 'public.status',
                    type: 'select',
                    paramsName: 'status',
                    isChooze: false,
                    selectParam: []
                },
                {
                    id: 4,
                    text: $t('integration.approval'),
                    type: 'select',
                    paramsName: 'approve',
                    isChooze: false,
                    selectParam: []
                },
                {
                    id: 5,
                    text: 'public.carrier',
                    type: 'input',
                    paramsName: 'carrierName',
                    isChooze: false
                },
                {
                    id: 6,
                    text: $t('integration.approver'),
                    type: 'input',
                    paramsName: 'approveName',
                    isChooze: false
                }
            ],
            SearchForm: {
                startDateArray: [],
                time: null,
                status: null,
                approve: null,
                carrierName: null,
                approveName: null,
                carrierId: null
            },
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: ['delRange'],
                    text: $t('integration.approval'),
                    method: 'appoveFn'
                },
                {
                    id: 2,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'public.tbopt_delete',
                    method: 'delFn'
                },
                {
                    id: 3,
                    icon: '',
                    vHas: ['delRange'],
                    text: $t('integration.export'),
                    method: 'exportFn'
                }
            ],
            rightArray: [
                {
                    id: 1,
                    color: 'green',
                    icon: 'el-icon-circle-check',
                    text: $t('integration.approved')
                },
                {
                    id: 2,
                    color: 'red',
                    icon: 'el-icon-circle-close',
                    text: $t('integration.approval_rejected')
                },
                {
                    id: 3,
                    color: 'grey',
                    icon: 'el-icon-circle-close',
                    text: $t('integration.not_approved')
                }
            ],
            choozeTableData: [],
            dateArray: [],
            // 数据记录点弹窗
            isPointShow: false,
            // 数据点分页
            pointId: '',
            isShow: false
        };
    },
    created() {
        this.Headertitle = this.$route.query['fullpath'] + '-' + $t('public.detail');
        this.defaultDate();
        this.ApprovalFn();
    },
    methods: {
        /** 获取审批状态 */
        ApprovalFn() {
            // 其实像这种共用接口应该早点做好的 fuck 了  后期才给
            let P1 = carrierRecordDetail({ code: 'acquisition_status', type: 0 });
            let P2 = carrierRecordDetail({ code: 'approval_status', type: 0 });
            // let P3 = carrierRecordDetail({code:'approval_status',type:0});
            Promise.all([P1, P2]).then(res => {
                this.formContent[3].selectParam = res[1].result.map(item => {
                    return {
                        label: getLanguage() === 'zh_CN'?item.name: item.content,
                        value: item.code
                    };
                });
                this.formContent[3].selectParam.splice(0, 0, {
                    label: $t('integration.please_select'),
                    value: null
                });
                this.formContent[2].selectParam = res[0].result.map(item => {
                    return {
                        label: getLanguage() === 'zh_CN'?item.name: item.content,
                        value: item.code
                    };
                });
                this.formContent[2].selectParam.splice(0, 0, {
                    label: $t('integration.please_select'),
                    value: null
                });
            });
        },
        defaultDate() {
            let curYear,
                curMonth = '';
            let nextYear = '',
                nextMonth = '';
            curYear = new Date().getFullYear();
            (curMonth = new Date().getMonth() + 1), (nextMonth = curMonth + 1);
            if (curMonth >= 13) {
                nextMonth = 1;
                nextYear = curYear + 1;
            } else {
                nextYear = curYear;
            }
            let startDate = curYear + '-' + curMonth + '-' + '01';
            let endDate = nextYear + '-' + nextMonth + '-' + '01';
            this.dateArray = [startDate, endDate];
        },
        getListFn() {
            this.SearchForm.carrierId = this.$route.query.id;
            this.loading = true;
            if (this.SearchForm.time && this.SearchForm.time.length > 0) {
                this.SearchForm.approveStartTime = this.$dateParseTime(this.SearchForm.time[0]);
                this.SearchForm.approveEndTime = this.$dateParseTime(this.SearchForm.time[1]);
            } else {
                this.SearchForm.approveStartTime = null;
                this.SearchForm.approveEndTime = null;
            }
            let param = {};
            if (this.SearchForm.startDateArray && this.SearchForm.startDateArray.length === 0) {
                param.startDate = this.dateArray[0];
                param.endDate = this.dateArray[1];
            } else {
                param.startDate = this.SearchForm.startDateArray[0];
                param.endDate = this.SearchForm.startDateArray[1];
            }

            for (let key in this.SearchForm) {
                param[key] = this.SearchForm[key];
            }
            delete param['time'], delete param['startDateArray'];
            carrierRecordList(param)
                .then(({ result, pageInfo }) => {
                    this.tableData = result;
                    this.total = pageInfo.total;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        resetFn() {
            (this.SearchForm = {
                startDateArray: [],
                time: null,
                status: null,
                approve: null,
                carrierName: null,
                approveName: null,
                carrierId: null
            }),
                this.getListFn();
        },
        choozeTable(row) {
            this.choozeTableData = row;
        },
        /** 单条删除 */
        delRowFn(row) {
            this.$confirm(this.$t('messageTitle.DeleteToContinue'))
                .then(() => {
                    carrieDel({ ids: row.id }).then(({ result, state }) => {
                        if (state.code === 200) {
                            if (result === 0) {
                                this.$message.error(this.$t('public.tip_del_fail'));
                            } else if (result === 1) {
                                this.$message.success($t('integration.successfully_deleted'));
                                this.getListFn();
                            } else {
                                this.$message.success($t('integration.system_error'));
                            }
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => {});
        },
        /** 多条审批 */
        appoveFn() {
            console.log(this.choozeTableData);
            if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let flag = this.distinguishTypeFn('approve');
            console.log(flag);
            if (!flag) return this.$message.error($t('integration.the_selected_data_has_approved_data'));
            let flag2 = this.distinguishTypeFn('carrierName');
            if (!flag2) return this.$message.error($t('integration.please_select_the_same_mounting_data_for_approval'));
            let flag3 = this.distinguishTypeFn('record_date');
            console.log(flag3);
            if (!flag3) return this.$message.error($t('integration.please_select_the_same_time_record_point_data'));
            this.title = $t('integration.approval');
            this.isShow = true;
        },
        /** 导出 */
        async exportFn() {
            if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let pointIds = this.choozeTableData.map(item => item.id);
            const params = {
                pointIds,
                isCoverage: 0,
                from: new Date(this.SearchForm.startDateArray[0]).getTime(),
                to: new Date(this.SearchForm.startDateArray[1]).getTime()
            };
            let result = (await carrieExport(params)).result;
            if (result.status === 300) {
                await this.$confirm($t('integration.the_file_already_exists._do_you_want_to_overwrite_it'));
                params.isCoverage = 1;
                result = (await carrieExport(params)).result;
            }
            if (result.status === 200) this.$store.state.downLoad.listids.push(result.recordId);
        },
        /** 区分勾选中的数据是否是已经审批 */
        distinguishTypeFn(str) {
            if (this.choozeTableData.length === 1) {
                return this.choozeTableData[0].approve === 1 ? false : true;
            }

            let oneParam = this.choozeTableData[0];
            let flag = true;
            for (let item of this.choozeTableData) {
                if (oneParam[str] !== item[str]) {
                    flag = false;
                    break;
                } else {
                    flag = true;
                }
            }
            return flag;
        },
        /** 单条审批通过 */
        approveFn(row, num) {
            this.$confirm()
                .then(() => {
                    carrierRecordUpdate({
                        id: row.id,
                        approve: num
                    }).then(({ state }) => {
                        if (state.code === 200) {
                            this.$message.success(this.$t('public.tip_oper_succ'));
                            this.getListFn();
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => {});
        },
        /** 数据详细 */
        detailFn(row) {
            this.title = `[${row.carrierName}][${row.recordDate}]-数据记录`;
            this.isPointShow = true;
            this.pointId = row.id;
        }
    }
};
</script>

<style lang="scss" scoped>
.pointPage {
    height: 100%;
    .headerClass {
        height: 60px;
        line-height: 60px;
        padding-bottom: 10px;
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
        text-align: center;
        font-size: 22px;
        font-weight: bold;
    }
    .pointContent {
        padding: 15px;
        padding-top: 0;
    }
    .pagination {
        padding-top: 0;
        padding-right: 15px !important;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .question {
        position: absolute;
        right: 20px;
        top: 75px;
        font-size: 18px;

        color: #9bccfd;
    }
}
</style>
